import styled from 'styled-components';
import H5 from '../../typography/H5';
import query from '../../../const/mediaQueries';
export const DrawerHeaderBase = styled.div `
  display: flex;
  flex-direction: row;
`;
export const LogoWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 56px;
  max-width: 58px;
  max-height: 58px;

  @media ${query.greaterThanSmall} {
    height: 85px;
    max-width: 88px;
    max-height: 88px;
  }
`;
export const AccountDetailsWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;

  @media ${query.greaterThanSmall} {
    padding-left: 8px;
  }
`;
export const TitleWrapper = styled.div `
  display: flex;
  align-items: center;
`;
export const Title = styled(H5) `
  white-space: nowrap;
`;
export const Image = styled.img `
  max-width: 100%;
  min-height: 1px;
  object-fit: contain;
`;
